import React,{useState,useRef,useEffect} from 'react';
import ogImage from '../../assets/images/og.jpeg';
import tlImage from '../../assets/images/tl.jpeg';
import locales from '../../locales/locales';
const SliderDemo=({globalSettings})=>{
  const [sliderPosition,setSliderPosition]=useState(50);
  const containerRef=useRef(null);
  const isDragging=useRef(false);
  useEffect(()=>{
    const handleMouseMove=(e)=>{
      if(!isDragging.current||!containerRef.current){
        return;
      }
      const rect=containerRef.current.getBoundingClientRect();
      const x=e.clientX-rect.left;
      const percentage=Math.max(0,Math.min(100,(x/rect.width)*100));
      setSliderPosition(percentage);
    };
    const handleMouseUp=()=>{
      isDragging.current=false;
      document.body.style.cursor='';
      document.body.style.userSelect='';
    };
    document.addEventListener('mousemove',handleMouseMove);
    document.addEventListener('mouseup',handleMouseUp);
    return ()=>{
      document.removeEventListener('mousemove',handleMouseMove);
      document.removeEventListener('mouseup',handleMouseUp);
    };
  },[]);
  const handleMouseDown=()=>{
    isDragging.current=true;
    document.body.style.cursor='ew-resize';
    document.body.style.userSelect='none';
  };
  const handleContainerMouseMove=(e)=>{
    if(isDragging.current||!containerRef.current){
      return;
    }
    const rect=containerRef.current.getBoundingClientRect();
    const x=e.clientX-rect.left;
    const percentage=Math.max(0,Math.min(100,(x/rect.width)*100));
    setSliderPosition(percentage);
  };
  return (
    <div className='bg-white p-6 rounded-xl shadow-lg border border-gray-200 w-full max-w-4xl'>
      <div 
        ref={containerRef}
        className='relative w-full aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden cursor-ew-resize'
        onMouseMove={handleContainerMouseMove}
      >
        <div className='absolute inset-0'>
          <img 
            src={tlImage} 
            alt='Translated manga'
            className='w-full h-full object-cover'
            draggable={false}
          />
        </div>
        <div 
          className='absolute inset-0 overflow-hidden'
          style={{clipPath:`inset(0 ${100-sliderPosition}% 0 0)`}}
        >
          <img 
            src={ogImage} 
            alt='Original manga'
            className='w-full h-full object-cover'
            draggable={false}
          />
        </div>
        <div 
          className='absolute top-0 bottom-0 w-1 bg-white shadow-lg cursor-ew-resize z-10 flex items-center justify-center'
          style={{left:`${sliderPosition}%`,transform:'translateX(-50%)'}}
          onMouseDown={handleMouseDown}
        >
          <div className='w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center'>
            <div className='w-3 h-3 border-l-2 border-r-2 border-gray-400'></div>
          </div>
        </div>
        <div className='absolute top-4 left-4 bg-black bg-opacity-70 text-white px-3 py-1 rounded-full text-sm font-medium'>
          {locales.sliderDemoOriginal[globalSettings.lang]}
        </div>
        <div className='absolute top-4 right-4 bg-black bg-opacity-70 text-white px-3 py-1 rounded-full text-sm font-medium'>
          {locales.sliderDemoTranslated[globalSettings.lang]}
        </div>
      </div>
    </div>
  );
};
export default SliderDemo;

